
import { defineComponent, reactive, onBeforeUnmount } from 'vue'

import type { DispatcherWorkplaceDataEntity } from '@/modules/DispatcherWorkplaceModule/types'

import DwHeader from '@/modules/DispatcherWorkplaceModule/components/DwHeader/index.vue'
import DwContainer from '@/modules/DispatcherWorkplaceModule/components/DwContainer/index.vue'
import DwSidebar from '@/modules/DispatcherWorkplaceModule/components/DwSidebar/index.vue'
import DwMap from '@/modules/DispatcherWorkplaceModule/components/DwMap/index.vue'
import DwStatement from '@/modules/DispatcherWorkplaceModule/components/DwStatement/index.vue'
import DwLegends from '@/modules/DispatcherWorkplaceModule/components/DwLegends/index.vue'

import DwChangeDatePopup from '@/modules/DispatcherWorkplaceModule/components/popups/DwChangeDatePopup/index.vue'
import DwAddToWaitListPopup from '@/modules/DispatcherWorkplaceModule/components/popups/DwAddToWaitListPopup/index.vue'
import DwAssignPopup from '@/modules/DispatcherWorkplaceModule/components/popups/DwAssignPopup/index.vue'
import DwSelfDeliveryPopup from '@/modules/DispatcherWorkplaceModule/components/popups/DwSelfDeliveryPopup/index.vue'
import DwSelfPickupListPopup from '@/modules/DispatcherWorkplaceModule/components/popups/DwSelfPickupListPopup/index.vue'
import DwSelfDeliveryListPopup from '@/modules/DispatcherWorkplaceModule/components/popups/DwSelfDeliveryListPopup/index.vue'
import DwMassAppointmentPopup from '@/modules/DispatcherWorkplaceModule/components/popups/DwMassAppointmentPopup/index.vue'

import useUseCase from '@/modules/DispatcherWorkplaceModule/use-cases/DispatcherWorkplace.use-case'

export default defineComponent({
    components: {
        'dispatcher-workplace-header': DwHeader,
        'dispatcher-workplace-container': DwContainer,
        'dispatcher-workplace-sidebar': DwSidebar,
        'dispatcher-workplace-map': DwMap,
        'dispatcher-workplace-statement': DwStatement,
        'dispatcher-workplace-legends': DwLegends,
        'dispatcher-workplace-change-date-popup': DwChangeDatePopup,
        'dispatcher-workplace-add-to-wait-list-popup': DwAddToWaitListPopup,
        'dispatcher-workplace-assign-popup': DwAssignPopup,
        'dispatcher-workplace-self-delivery-popup': DwSelfDeliveryPopup,
        'dispatcher-workplace-self-pickup-list-popup': DwSelfPickupListPopup,
        'dispatcher-workplace-self-delivery-list-popup': DwSelfDeliveryListPopup,
        'dispatcher-workplace-mass-appointment-popup': DwMassAppointmentPopup,
    },
    setup() {
        const state = reactive({
            is_sidebar_opened: true,
        })

        const dispatcherWorkplace = useUseCase()

        const onSidebarToggled = (is_opened: boolean) => {
            state.is_sidebar_opened = is_opened
        }

        onBeforeUnmount(() => {
            // dispatcherWorkplace.intervalController.stop()
        })

        return { state, onSidebarToggled, dispatcherWorkplace }
    },
})
